module.exports = __webpack_public_path__ + "static/google-certificates-ccb2f557b894b8cb5e26789804b7f4bf.png";